<template>
  <div class="header">
    <Desktop v-if="!mobile" :menu="menu" />
    <Mobile v-else :menu="menu" />
  </div>
</template>

<script>
import Desktop from "./Desktop.vue";
import Mobile from "./Mobile.vue";
import { getMenu } from "../../../config";

export default {
  data: () => ({
    scrolled: 0,
  }),
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    social() {
      return this.$rest("social").list;
    },
    projects() {
      return this.$rest("projects-topics").list;
    },
    services() {
      return this.$rest("services").list;
    },
    menu() {
      return getMenu(this);
    },
  },
  components: {
    Desktop,
    Mobile,
  },
};
</script>

<style scoped>
.header {
  z-index: 630;
}

@media screen and (max-width: 1264px) {
  .page-title {
    margin-top: 64px;
  }

  .header {
    z-index: 99999 !important;
  }
}

@media screen and (max-width: 960px) {
  .page-title {
    margin-top: 56px;
  }
}
</style>
